import { ungzip } from 'pako'

/**
 * Soketi delivers every event as gzipped JSON, base64-encoded.
 *
 * This is the single point all live updates pass through — container updates,
 * gate schedules and notifications alike — so a silent break here stops all of
 * them at once with nothing in the UI to indicate why. It lives here, apart from
 * `useSoketi`, because it is pure: the composable it came from opens real
 * WebSocket connections and is mocked wholesale in `test/setup.ts`, which left
 * the decode itself untestable.
 */
export function decodeSoketiEvent(base64GzippedEvent: string): any {
  const compressedEvent = base64ToByteArray(base64GzippedEvent)
  // pako 3 renamed the text-output option from `{ to: 'string' }` and dropped
  // its default export, so this must stay a named import: a default one still
  // typechecks under esModuleInterop but is `undefined` at runtime, which would
  // silently stop every live update rather than failing the build.
  const eventJSON = ungzip(compressedEvent, { toText: true })
  return JSON.parse(eventJSON)
}

function base64ToByteArray(base64: string): Uint8Array {
  const binaryString = window.atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; ++i) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
